export function validateContactInputs(leadBookerForm, partyDetailsForm) {
    const mobile = leadBookerForm.querySelector('#atb-mobile');
    const fields = [...leadBookerForm.querySelectorAll('input:not([type]), input[type="text"], input[type="email"], input[type="tel"], textarea'),
                    ...partyDetailsForm.querySelectorAll('input:not([type]), input[type="text"], input[type="email"], input[type="tel"], textarea')];

    for (const field of fields) {
        if (field.hasAttribute('data-is-js-template')) continue;
        // Re-check on every edit so the field can recover without another submit.
        if (!field.dataset.contactValidationBound) {
            field.addEventListener('input', () => validateContactInputs(leadBookerForm, partyDetailsForm));
            field.dataset.contactValidationBound = 'true';
        }
        const value = field.value.trim();
        const blankRequired = field.required && value === '';
        const invalidMobile = field === mobile && field.value !== '' && !/[0-9]/.test(value);
        field.setCustomValidity(blankRequired || invalidMobile ? 'Please provide a valid value.' : '');
    }
}
